/**
 * The type of track this is
 */
export var Type;
(function (Type) {
    /**
     * A normal song
     */
    Type[Type["Track"] = 0] = "Track";
    /**
     * An event, containing only the `artist` column and no `title`. TODO: Should these be switched?
     */
    Type[Type["Event"] = 1] = "Event";
})(Type || (Type = {}));
/**
 * The available streaming services that may be linked.
 */
export var Service;
(function (Service) {
    /**
     * Spotify, using the WITR Spotify account for credentials.
     */
    Service[Service["Spotify"] = 0] = "Spotify";
})(Service || (Service = {}));
/**
 * Gets the track type from a string.
 *
 * @param type The lowercase type
 */
function typeFromName(type) {
    if (type == 'track') {
        return Type.Track;
    }
    else if (type == 'event') {
        return Type.Event;
    }
    return Type.Track;
    // TODO
    // throw 'Invalid type: ' + type
}
/**
 * Gets the streaming service from its name
 *
 * @param service The lowercase service name
 */
function serviceFromName(service) {
    if (service == 'spotify') {
        return Service.Spotify;
    }
    // TODO
    return Service.Spotify;
}
/**
 * Data for a track collected from a specific streaming service.
 */
var StreamingLink = /** @class */ (function () {
    /**
     * Creates a StreamingLink.
     *
     * @param link The link to the song on the streaming service
     * @param albumArt A link to the album art
     * @param service The service this object is for
     */
    function StreamingLink(link, albumArt, service) {
        this.link = link;
        this.artwork = albumArt;
        this.service = service;
    }
    return StreamingLink;
}());
export { StreamingLink };
/**
 * Either a song or event that may be displayed as a line in a logger instance.
 */
var Track = /** @class */ (function () {
    /**
     * Creates a Track.
     *
     * @param id The track's ID
     * @param artist The artist name
     * @param title The title
     * @param time The time this was played at
     * @param group The track's group
     * @param type The type of track
     * @param streaming Any available streaming links
     */
    function Track(id, artist, title, time, group, type, streaming) {
        this.id = id;
        this.artist = artist;
        this.title = title;
        this.time = time;
        this.group = group;
        this.type = type;
        this.streaming = streaming;
    }
    /**
     * Creates a `Track` from given JSON input (generally provided by the server).
     *
     * @param json The JSON input
     */
    Track.fromJSON = function (json) {
        return new Track(json['id'], json['artist'], json['title'], new Date(Date.parse(json['time'])), json['group'], typeFromName(json['type']), Track.parseStreaming(json['streaming']));
    };
    /**
     * Parses a JSON array into an array of `StreamingLink`s.
     *
     * @param services The JSON array
     */
    Track.parseStreaming = function (services) {
        return services.map(function (json) { return new StreamingLink(json['link'], json['artwork'], serviceFromName(json['service'])); });
    };
    /**
     * Checks if the track is an event (checking by its group).
     */
    Track.prototype.isEvent = function () {
        return this.group == 'Event';
    };
    /**
     * Gets the album art (if found) from the Spotify service.
     */
    Track.prototype.getAlbumArt = function () {
        var _a;
        if (this.streaming.length == 0) {
            return undefined;
        }
        return (_a = this.streaming.find(function (streaming) { return streaming.artwork != undefined; })) === null || _a === void 0 ? void 0 : _a.artwork;
    };
    return Track;
}());
export { Track };
/**
 * A track that has been sent from the server.
 */
var TrackBroadcast = /** @class */ (function () {
    function TrackBroadcast(track, requested) {
        this.track = track;
        this.requested = requested;
    }
    /**
     * Creates a {@link TrackBroadcast} from given JSON input.
     *
     * @param json The JSON input
     */
    TrackBroadcast.fromJSON = function (json) {
        return new TrackBroadcast(Track.fromJSON(json['track']), json['requested']);
    };
    return TrackBroadcast;
}());
export { TrackBroadcast };
